



































import {Component, Vue, Prop} from 'vue-property-decorator';
import AccelerometerSegmentDiagram from '@/components/widgets/AccelerometerSegmentDiagram.vue';
import WidgetBindDataSource from '@/components/widgets/base/WidgetBindDataSource.vue';
import AccelerometerWidgetBindForm from '@/components/widgets/base/bindForms/AccelerometerWidgetBindForm.vue';
import {AxisBindData, AxisBoundaries} from '@/components/widgets/base/bindForms/interfaces';
import {PModuleType} from '@/enums/configs';
import {MeasurementType} from '@/views/system/measurements/enums';
import {pmoduleStoresByTypeMap} from '@/views/system/modules/configurate';
import {PModuleStoreModule} from '@/store/modules/entities/pmodules/interfaces';
import {PModuleWithMeasurements} from '@/views/system/modules/interfaces';

@Component({
  components: {
    AccelerometerSegmentDiagram,
    WidgetBindDataSource,
    AccelerometerWidgetBindForm,
  },
})
export default class AccelerometerWidget extends Vue {
  @Prop({required: true})
  axis!: AxisBindData;

  @Prop({required: true})
  currentValue!: number;

  @Prop({required: true})
  resizedKey!: number;

  @Prop({required: false})
  boundaries!: AxisBoundaries;

  @Prop({required: false})
  unit!: string;

  // предустановленный фильтр с типом ПМ для выбора источника данных виджета
  presetFilter = [PModuleType.DtcpAccelerometerModule];

  presetMeasurementFilter = [MeasurementType.Signal];
  // Получение данных оси
  get axisData() {
    if (this.axis && this.axis.moduleGUID && this.axis.measurementId)
      return {
        nodeId: this.axis.nodeId,
        moduleId: this.axis.moduleId,
        moduleGUID: this.axis.moduleGUID,
        moduleType: this.axis.moduleType,
        measurementId: this.axis.measurementId,
        boundaries: this.axis.boundaries,
      };
    return {nodeId: undefined, moduleGUID: undefined, measurementId: undefined};
  }

  // Действия при выборе оси
  async onAxisSelect(data: AxisBindData) {
    const store = (pmoduleStoresByTypeMap.get(
      data.moduleType as PModuleType,
    ) as any) as PModuleStoreModule;

    const pmoduleData = await store.getById(data.pmodule?.id);
    const pmodule = pmoduleData.data as PModuleWithMeasurements;
    const pmoduleMeasurement = pmodule.measurements.filter(
      m => m.measurementId === data.measurementId,
    )[0];

    if (!pmoduleMeasurement) return;

    const axisFormData = (this.$refs.axisBindForm as any).axis as AxisBindData;
    this.$emit('bind', {
      ...axisFormData,
      nodeId: data.nodeId,
      moduleId: data.pmodule?.id,
      moduleGUID: data.moduleGUID,
      moduleType: data.moduleType,
      measurementId: data.measurementId,
      boundaries: {
        warningBoundary: pmoduleMeasurement.topWarningBoundary,
        errorBoundary: pmoduleMeasurement.topErrorBoundary,
        dangerBoundary: pmoduleMeasurement.topDangerBoundary,
      },
    });
  }
}
